import React from "react";
import type { ResponsiveValue } from "../../breakpoints";
import { cn } from "../../utils/cn";
import styles from "./styles.module.scss";

interface LogoProps {
  size?: ResponsiveValue<string | number>;
  className?: string;
  style?: React.CSSProperties;
}

const Logo: React.FC<LogoProps> = ({ size = 22, style, className }) => {
  const isResponsive = typeof size === "object" && size !== null;
  const responsiveStyles: Record<string, string> = {};

  if (!isResponsive) {
    const varName = "--lf-logo-size";
    responsiveStyles[varName] = typeof size === "number" ? `${size}px` : size;
  } else {
    const breakpoints = ["base", "xs", "sm", "md", "lg", "xl", "xxl"];
    const responsiveSizes = size as Record<string, string | number>;

    breakpoints.forEach((bp) => {
      const val = responsiveSizes[bp];
      if (val !== undefined) {
        const varName = bp === "base" ? "--lf-logo-size" : `--lf-logo-size-${bp}`;
        responsiveStyles[varName] = typeof val === "number" ? `${val}px` : val;
      }
    });
  }

  return (
    <svg
      className={cn(styles.logo, className)}
      style={{
        ...responsiveStyles,
        ...style,
      }}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5925_9949)">
        <rect
          width="22"
          height="21.9963"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3431 5.16135C16.1803 5.08175 16.9851 5.23842 17.7213 5.65701C18.9622 6.36274 19.7696 7.69235 20.1422 9.04733C20.633 10.8328 20.5227 13.0394 19.605 14.6723C18.9628 15.8151 18.0558 16.4602 16.8111 16.8011L16.7692 16.8092C15.798 16.9862 14.8623 16.7565 14.0594 16.1882C12.8162 15.3085 12.0769 13.7954 11.8245 12.3159C11.5108 10.478 11.7427 8.33487 12.8438 6.78441C13.4852 5.88151 14.2563 5.34731 15.3431 5.16135ZM13.985 13.6654C14.4979 13.4239 14.7996 13.0252 14.9905 12.4975C15.3058 11.625 15.3136 10.5268 14.9152 9.67893C14.7225 9.26903 14.4068 8.89557 13.9672 8.75263C13.7954 8.69672 13.6362 8.70863 13.4591 8.72572C12.9933 8.90958 12.6982 9.25306 12.5004 9.70654C12.1174 10.5846 12.114 11.6776 12.4619 12.5669C12.6275 12.9901 12.8944 13.45 13.3275 13.6334C13.5555 13.7301 13.7511 13.7339 13.985 13.6654ZM6.52343 6.69472C6.11522 6.37221 5.67399 6.24261 5.15872 6.29138C4.32044 6.42648 3.61594 6.83142 3.1107 7.52956C2.12782 8.88807 1.92609 10.8807 2.18485 12.5075C2.34331 13.5045 2.75185 14.6613 3.58799 15.2792C3.64216 15.3189 3.69784 15.3563 3.75502 15.3913C3.81212 15.4263 3.87057 15.459 3.93038 15.4892C3.99011 15.5194 4.05097 15.5471 4.11296 15.5723C4.17494 15.5975 4.23783 15.62 4.30162 15.64C4.36541 15.66 4.42991 15.6773 4.49513 15.6919C4.56035 15.7066 4.62601 15.7185 4.69213 15.7277C4.75825 15.7369 4.82467 15.7434 4.89139 15.7471C4.95803 15.7509 5.02472 15.7518 5.09144 15.75C5.90345 15.6515 6.5143 15.3436 7.02687 14.682C7.97852 13.4542 8.25149 11.4941 8.0644 9.97788C7.92026 8.80953 7.47362 7.44553 6.52343 6.69472ZM7.14683 12.443C7.03706 12.782 6.88164 13.0575 6.55808 13.2219C6.51367 13.2263 6.47085 13.2298 6.42633 13.2231C6.24308 13.1958 6.0942 13.0719 5.9869 12.9244C5.54635 12.3189 5.51389 11.2551 5.63099 10.5438C5.718 10.0158 5.91015 9.53447 6.34856 9.21447L6.35184 9.21443C6.41417 9.21364 6.47878 9.21282 6.53926 9.22936C6.76511 9.29129 6.93788 9.4905 7.04427 9.69234C7.44448 10.4523 7.4056 11.644 7.14683 12.443Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5925_9949">
          <rect
            width="22"
            height="22"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export { Logo };
